(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products-bundle"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('.product-bundle-card__atc-btn a');
    if (!link) return;

    // 购物车页面或者没开 drawer 的时候，保持原来的跳转
    if (
      !window.FoxTheme ||
      document.body.classList.contains('cart-template') ||
      FoxTheme.settings.cartType != 'drawer'
    ) return;

    const variantId = new URL(link.href, window.location.origin).searchParams.get('id');
    if (!variantId) return;

    event.preventDefault();

    const btn = link.closest('.product-bundle-card__atc-btn');
    if (btn.classList.contains('btn--loading')) return; // 防止连点
    btn.classList.add('btn--loading');

    const bundle = link.closest('products-bundle');
    const errorEl = bundle && bundle.querySelector('.product-form__error-message');
    if (errorEl) errorEl.hidden = true;

    // 跟 Add all 一样，拿 drawer 需要刷新的 sections
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );

    try {
      const res = await fetch(FoxTheme.routes.cart_add_url, {
        ...FoxTheme.utils.fetchConfig('javascript'),
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections,
          section_url: window.location.pathname,
        }),
      });
      const state = await res.json();

      // 出错（比如库存不够）
      if (state.status) {
        if (errorEl) {
          errorEl.textContent = state.description;
          errorEl.hidden = false;
        } else {
          alert(state.description);
        }
        return;
      }

      const cartJson = await (
        await fetch(FoxTheme.routes.cart_url, { ...FoxTheme.utils.fetchConfig() })
      ).json();
      cartJson.sections = state.sections;

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: state } }));

      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.show(btn);
      } else {
        window.location.href = FoxTheme.routes.cart_url;
      }
    } catch (e) {
      console.error(e);
    } finally {
    btn.classList.remove('btn--loading');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
